import { INPUTS_PAGE_NAV_TITLE } from "pages/InputsPage";
import { SYSTEM_DROPDOWN_TITLE } from "components/navigation/bindings";
import InputsDotBadge from "components/inputs/InputsDotBadge";
import fetchForwarderNode from "forwarder/fetchForwarderNode";
import fetchForwarderInput from "forwarder/fetchForwarderInput";
import Routes from "routing/Routes";
import AppConfig from "util/AppConfig";
import ForwarderPage from "./ForwarderPage";
import ForwardersPage from "./ForwardersPage";
import InputProfilesPage from "./InputProfilesPage";
import InputProfilePage from "./InputProfilePage";
import NewInputProfilePage from "./NewInputProfilePage";
import ForwarderWizardPage from "./wizard/ForwarderWizardPage";
import ForwarderInputDropdown from "./message-loaders/ForwarderInputDropdown";
import ForwarderReceivedBy from "./message-details/ForwarderReceivedBy";
import isLocalNode from "./message-details/isLocalNode";
import ForwarderRoutes from "./Routes";
import ForwarderInputsPage from "./ForwarderInputsPage";
import useForwarderInputsBadgeCondition from "./useForwarderInputsBadgeCondition";
import ForwarderInputsTabDotBadge from "./ForwarderInputsTabDotBadge";
export const PAGE_NAV_TITLE = "Forwarder";
const forwarderBindings = {
  forwarder: [
    {
      ForwarderReceivedBy,
      isLocalNode,
      messageLoaders: {
        ForwarderInputDropdown
      },
      fetchForwarderInput,
      fetchForwarderNode
    }
  ],
  routes: [
    { path: ForwarderRoutes.unqualified.LIST, component: ForwardersPage },
    { path: ForwarderRoutes.unqualified.CREATE, component: ForwarderWizardPage },
    { path: ForwarderRoutes.unqualified.configure(":inputProfileId"), component: ForwarderWizardPage },
    { path: ForwarderRoutes.unqualified.details(":forwarderId"), component: ForwarderPage },
    { path: ForwarderRoutes.unqualified.PROFILE.LIST, component: InputProfilesPage },
    { path: ForwarderRoutes.unqualified.PROFILE.CREATE, component: NewInputProfilePage },
    { path: ForwarderRoutes.unqualified.PROFILE.details(":inputProfileId"), component: InputProfilePage },
    { path: ForwarderRoutes.unqualified.FORWARDER_INPUTS, component: ForwarderInputsPage }
  ],
  navigation: AppConfig.isCloud() ? [
    {
      description: SYSTEM_DROPDOWN_TITLE,
      children: [
        {
          path: ForwarderRoutes.LIST,
          description: "Forwarders",
          permissions: ["forwarders:read", "inputprofiles:read"]
        }
      ]
    }
  ] : [],
  pageNavigation: [
    {
      description: PAGE_NAV_TITLE,
      children: [
        { description: "Forwarders", path: ForwarderRoutes.LIST, exactPathMatch: true },
        { description: "Input Profiles", path: ForwarderRoutes.PROFILE.LIST }
      ]
    },
    {
      description: INPUTS_PAGE_NAV_TITLE,
      children: [
        { description: "Inputs", path: Routes.SYSTEM.INPUTS, exactPathMatch: true, BadgeComponent: InputsDotBadge },
        { description: "Forwarder Inputs", path: ForwarderRoutes.FORWARDER_INPUTS, BadgeComponent: ForwarderInputsTabDotBadge }
      ]
    }
  ],
  inputsBadgeProviders: [
    { useCondition: useForwarderInputsBadgeCondition }
  ],
  entityTypeRoute: [
    {
      type: "forwarder",
      route: (id) => ForwarderRoutes.details(id)
    }
  ]
};
export default forwarderBindings;
